import React from 'react';
import Input from '../Input/Input';
import './GuestDetailsForm.css';

const GuestDetailsForm = ({ formData, onChange, errors = {} }) => {
  const handleChange = (field, value) => {
    onChange?.({ ...formData, [field]: value });
  };

  return (
    <div className="guest-details-form">
      <h2 className="guest-details-form__title">Guest Information</h2>
      
      <div className="guest-details-form__section">
        <h3 className="guest-details-form__section-title">Primary Guest</h3>
        <div className="guest-details-form__fields">
          <div className="guest-details-form__field">
            <Input
              type="text"
              label="First Name"
              placeholder="John"
              value={formData?.firstName || ''}
              onChange={(e) => handleChange('firstName', e.target.value)}
              required
              error={errors.firstName}
            />
          </div>
          
          <div className="guest-details-form__field">
            <Input
              type="text"
              label="Last Name"
              placeholder="Doe"
              value={formData?.lastName || ''}
              onChange={(e) => handleChange('lastName', e.target.value)}
              required
              error={errors.lastName}
            />
          </div>
          
          <div className="guest-details-form__field">
            <Input
              type="email"
              label="Email Address"
              placeholder="john.doe@example.com"
              value={formData?.email || ''}
              onChange={(e) => handleChange('email', e.target.value)}
              required
              error={errors.email}
            />
          </div>
          
          <div className="guest-details-form__field">
            <Input
              type="tel"
              label="Phone Number"
              placeholder="+1 (555) 123-4567"
              value={formData?.phone || ''}
              onChange={(e) => handleChange('phone', e.target.value)}
              required
              error={errors.phone}
            />
          </div>

          <div className="guest-details-form__field">
            <Input
              type="text"
              label="Nationality"
              placeholder="British"
              value={formData?.nationality || ''}
              onChange={(e) => handleChange('nationality', e.target.value)}
              error={errors.nationality}
            />
          </div>
        </div>
      </div>

      <div className="guest-details-form__section">
        <h3 className="guest-details-form__section-title">Special Requests</h3>
        <div className="guest-details-form__field">
          <label className="input__label">
            Additional Notes
            <textarea
              className="input"
              placeholder="Any special requests or notes for your stay..."
              value={formData?.specialRequests || ''}
              onChange={(e) => handleChange('specialRequests', e.target.value)}
              rows="4"
            />
          </label>
        </div>
      </div>
    </div>
  );
};

export default GuestDetailsForm;
